<template><claim-list :risk-type="1"/></template>
<script>
import ClaimList from "./ClaimList.vue";
export default { name: "CargoClaims", components: { ClaimList } };
</script>
